import { Breadcrumb, Button, message, PageHeader, Table, Checkbox } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { Auth } from "_helpers";
import TabMenu from "./TabMenu";
import { employeeService, jobService } from "_services";

function Recourses({ history, match }) {
  const { id } = match.params;
  const { path } = match;
  const [isLoading, setIsLoading] = useState(false);
  const [item, setItem] = useState({});
  const [employees, setEmployees] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);

  useEffect(() => {
    getJobById();
    getRecourses();
  }, []);

  const getJobById = () => {
    setIsLoading(true);
    jobService
      .getById(id)
      .then((x) => {
        const alreadySelectedEmployeeList = x.content?.employees?.map(
          (singleEmployee) => {
            return singleEmployee?.id;
          }
        );
        setItem(x.content);
        setSelectedEmployees(alreadySelectedEmployeeList);
      })
      .catch((errorInfo) => {
        message.error(`${errorInfo}`);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const getRecourses = () => {
    setIsLoading(true);
    employeeService
      .getAll()
      .then((data) => {
        setEmployees(data.content);
      })
      .catch((error) => {
        message.error(`${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSubmit = () => {
    setIsLoading(true);
    const modifiedEmployeeList = selectedEmployees.map((singleEmployee) => {
      return { id: singleEmployee };
    });
    const payload = {
      ...item,
      employees: modifiedEmployeeList,
    };
    jobService
      .update(id, payload)
      .then((x) => {
      })
      .catch((error) => {
        message.error(`${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onCancel = () => {
    history.push("/jobs");
  };

  const getActionButtons = () => {
    let buttons = [];
    if (Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])) {
      buttons.push(
        <Button
          key="1"
          type="primary"
          htmlType="submit"
          loading={isLoading}
          disabled={selectedEmployees.length <= 0}
          onClick={() => handleSubmit()}
        >
          Allocate Recourse
        </Button>
      );
    }
    buttons.push(
      <Button key="2" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );
    return buttons;
  };

  const onChange = (checkedValues) => {
    setSelectedEmployees(checkedValues);
  };

  const columns = [
    {
      title: "Select employee",
      dataIndex: "selectEmployee",
      width: "10%",
      render: (text, record) => <Checkbox value={record.id}></Checkbox>,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => record.name,
    },
    {
      title: "NIC",
      dataIndex: "nic",
      key: "nic",
      render: (text, record) => record.nic ?? "",
    },
    {
      title: "Total Booked Mins",
      dataIndex: "totalBookedMins",
      key: "totalBookedMins",
      render: (text, record) => record.totalBookedMins ?? "-",
    },
    {
      title: "Total Labour Cost",
      dataIndex: "totalLabourCost",
      key: "totalLabourCost",
      render: (text, record) => record.totalLabourCost ?? "-",
    },
  ];

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/jobs">Job Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`${path}`}>Job : {item.code}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Recourses</Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner>
          <TabMenu menu="recourses" id={id} />
          {employees.length > 0 && (
            <Checkbox.Group style={{ width: "100%" }} onChange={onChange} value={selectedEmployees}>
              <Table
                bordered
                loading={isLoading}
                rowKey="id"
                size="small"
                columns={columns}
                dataSource={employees}
              />
            </Checkbox.Group>
          )}
        </Page>
      </PageHeader>
    </div>
  );
}

export default Recourses;
